import React, {useState} from "react";
import styles from './FAQ.module.scss'

export type FaqGroups = {
  [group: string]: Faq
}
export type Faq = Array<{
  [question: string]: string;
}>

type SelectedItem =
  | { groupIndex: number; itemIndex: number }
  | null;
export default ({items}: {items: FaqGroups | Faq}) => {

  const [selected, setSelected] = useState<SelectedItem>(null);

  const isSingle = Array.isArray(items)
  return <div className={[styles.faq, isSingle ? styles.single : null].join(' ')} >
        {Object.entries(items).map(([title, questions], groupIndex) => <div className={styles.group} key={groupIndex}>
            {!isSingle && <h2>{title}</h2>}
            {Object.entries(questions as object).map(([question, answer], questionIndex) =>
              <div key={questionIndex} className={`${styles.question} ${selected?.groupIndex === groupIndex && selected.itemIndex === questionIndex ? styles.open : ''}`} onClick={() => setSelected({groupIndex: groupIndex, itemIndex: questionIndex})}>
                <h4>{question}</h4>
                <div dangerouslySetInnerHTML={{__html: answer}}></div>
              </div>
            )}
          </div>
        )}
  </div>
}